export const getUserAvatar = user => {
  return (
    user?.funAvatarImageUrl ||
    user?.pic ||
    user?.thumbProfileImageFile?.url ||
    user?.cfTbImageUrl ||
    'https://didr9pubr8qfh.cloudfront.net/mobile_other/profile_avatars/Profile5.png'
  )
}
